// Reference page: tab bar only. Each tab lives in its own file under
// ./reference/ (split 2026-10-14 for readability):
//   PlatesPanel, CustomersPanel (+ CertRecipientsPanel, RateHistoryPanel),
//   ProjectsTab, VendorsPanel, EmployeesPanel, EquipmentPanel,
//   KnownVehicles (Yard vehicles), and admin-only PlantLocationPanel,
//   SmtpPanel, DailyMailPanel, PdfFieldsPanel, IssueRulesPanel.
import { useState } from 'react';
import { useApi } from '../api.js';
import KnownVehicles from './KnownVehicles.jsx';
import PlatesPanel from './reference/PlatesPanel.jsx';
import CustomersPanel from './reference/CustomersPanel.jsx';
import ProjectsTab from './reference/ProjectsTab.jsx';
import VendorsPanel from './reference/VendorsPanel.jsx';
import EmployeesPanel from './reference/EmployeesPanel.jsx';
import EquipmentPanel from './reference/EquipmentPanel.jsx';
import PlantLocationPanel from './reference/PlantLocationPanel.jsx';
import SmtpPanel from './reference/SmtpPanel.jsx';
import DailyMailPanel from './reference/DailyMailPanel.jsx';
import PdfFieldsPanel from './reference/PdfFieldsPanel.jsx';
import IssueRulesPanel from './reference/IssueRulesPanel.jsx';

export default function Reference({ canWrite = true }) {
  const [tab, setTab] = useState('plates');
  const { data: me } = useApi('/api/whoami');
  const isAdmin = !!(me && me.isAdmin);
  return (
    <div className="page">
      <div className="page-head"><h1>Reference data</h1></div>
      <div className="tabs">
        <button className={tab === 'plates'    ? 'tab active' : 'tab'} onClick={() => setTab('plates')}>Plates</button>
        <button className={tab === 'customers' ? 'tab active' : 'tab'} onClick={() => setTab('customers')}>Customers</button>
        <button className={tab === 'projects'  ? 'tab active' : 'tab'} onClick={() => setTab('projects')}>Projects</button>
        <button className={tab === 'vendors'   ? 'tab active' : 'tab'} onClick={() => setTab('vendors')}>Vendors</button>
        <button className={tab === 'employees' ? 'tab active' : 'tab'} onClick={() => setTab('employees')}>Employees</button>
        <button className={tab === 'equipment' ? 'tab active' : 'tab'} onClick={() => setTab('equipment')}>Equipment</button>
        <button className={tab === 'vehicles'  ? 'tab active' : 'tab'} onClick={() => setTab('vehicles')}>Yard vehicles</button>
        {isAdmin && (
          <button className={tab === 'plant' ? 'tab active' : 'tab'} onClick={() => setTab('plant')}>Plant location</button>
        )}
        {isAdmin && (
          <button className={tab === 'smtp' ? 'tab active' : 'tab'} onClick={() => setTab('smtp')}>SMTP / Email</button>
        )}
        {isAdmin && (
          <button className={tab === 'dailymail' ? 'tab active' : 'tab'} onClick={() => setTab('dailymail')}>Daily-report recipients</button>
        )}
        {isAdmin && (
          <button className={tab === 'pdffields' ? 'tab active' : 'tab'} onClick={() => setTab('pdffields')}>Daily-report PDF fields</button>
        )}
        {isAdmin && (
          <button className={tab === 'rules' ? 'tab active' : 'tab'} onClick={() => setTab('rules')}>Issue rules</button>
        )}
      </div>
      {tab === 'plates'    && <PlatesPanel canWrite={canWrite} />}
      {tab === 'customers' && <CustomersPanel canWrite={canWrite} />}
      {tab === 'projects'  && <ProjectsTab canWrite={canWrite} />}
      {tab === 'vendors'   && <VendorsPanel canWrite={canWrite} />}
      {tab === 'employees' && <EmployeesPanel canWrite={canWrite} />}
      {tab === 'equipment' && <EquipmentPanel canWrite={canWrite} />}
      {tab === 'vehicles'  && <KnownVehicles canWrite={canWrite} />}
      {tab === 'plant' && isAdmin && <PlantLocationPanel />}
      {tab === 'smtp' && isAdmin && <SmtpPanel />}
      {tab === 'dailymail' && isAdmin && <DailyMailPanel />}
      {tab === 'pdffields' && isAdmin && <PdfFieldsPanel />}
      {tab === 'rules' && isAdmin && <IssueRulesPanel />}
    </div>
  );
}
